import { render, staticRenderFns } from "./CreateW9CR.vue?vue&type=template&id=78b40099&scoped=true&"
import script from "./CreateW9CR.vue?vue&type=script&lang=ts&"
export * from "./CreateW9CR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b40099",
  null
  
)

export default component.exports